import script from "./RecordExpenseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordExpenseModal.vue?vue&type=script&setup=true&lang=ts"

import "./RecordExpenseModal.vue?vue&type=style&index=0&id=44d407e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44d407e1"]])

export default __exports__